import { is } from '@common/is/is'

import DOM from '@common/DOM/DOM'

import stoc from '@corp/website/stoc'

/**
 * Sikeres bejelentkezés esetén a válaszban kapott STOC-ot elrakjuk cookie-ba és
 * újra betöltjük az oldalt.
 * @param res  - A szervertől kapott válasz.
 * @param _xhr - Nem használt xhr.
 * @param form - Az eredeti form elemünk.
 */
export default function onSuccess (
  res: unknown,
  _xhr: XMLHttpRequest,
  form: HTMLFormElement
// eslint-disable-next-line custom/prefer-early-return
): void {
  if (
    is.object(res) &&
    is.property(res, 'loginHash') &&
    is.string(res.loginHash)
  ) {
    stoc.set(res.loginHash)

    // Elméletileg így valószínűbb, hogy minden esetben feldobja a jelszó mentésének engedélyezését.
    const cloneForm = form.cloneNode(true) as HTMLFormElement
    DOM.replace(form, cloneForm)

    cloneForm.submit()
  }
}
